import {
  REMOVE_LISTS,
  MATERIAL_QUOTA_ASSIGN_LOCATION,
  MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL,
  MATERIAL_QUOTA_ASSIGN_TABLE_LOG,
  MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT,
  MATERIAL_QUOTA_ASSIGN_PREVIEW,
  MATERIAL_QUOTA_ASSIGN_UPDATE,
  EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG,
} from './actions'

const initialState = {
  // *load ข้อมูลต้นแหล่ง
  source_list: [],
  check_source_list: false,

  // *load ข้อมูลวัตถุดิบ
  material_list: [],
  check_material_list: false,

  // *table log
  check_log_list: false,
  log_list: [],
  log_list_total: 0,

  // *load ข้อมูลวัตถุดิบ
  material_list_edit: [],
  check_material_list_edit: false,

  // *preview ข้อมูลโควตา
  preview_list: [],
  check_preview_list: false,

  // *update ข้อมูลโควตา
  update_list: [],
  check_update: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case MATERIAL_QUOTA_ASSIGN_LOCATION.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case MATERIAL_QUOTA_ASSIGN_LOCATION.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists || [],
        check_source_list: false,
      }

    case MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }
    case MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists || [],
        check_material_list: false,
      }

    case MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_log_list: true,
        log_list: [],
        log_list_total: 0,
      }
    case MATERIAL_QUOTA_ASSIGN_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_log_list: false,
        log_list: action.payload.lists.data || [],
        log_list_total: action.payload.lists.total || 0,
      }

    case MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.REQUEST:
      return {
        ...state,
        material_list_edit: [],
        check_material_list_edit: true,
      }

    case MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.SUCCESS:
      return {
        ...state,
        material_list_edit: action.payload.lists || [],
        check_material_list_edit: false,
      }

    case MATERIAL_QUOTA_ASSIGN_PREVIEW.REQUEST:
      return {
        ...state,
        preview_list: [],
        check_preview_list: true,
      }

    case MATERIAL_QUOTA_ASSIGN_PREVIEW.SUCCESS:
      return {
        ...state,
        preview_list: action.payload.lists || [],
        check_preview_list: false,
      }

    case MATERIAL_QUOTA_ASSIGN_UPDATE.REQUEST:
      return {
        ...state,
        update_list: [],
        check_update: true,
      }

    case MATERIAL_QUOTA_ASSIGN_UPDATE.SUCCESS:
      return {
        ...state,
        update_list: action.payload.lists || [],
        check_update: false,
      }
    case EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_source_list: true,
      }
    
    case EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_source_list: false,
      }
      
    default:
      return state
  }
}
